<template>
    <el-drawer
        class="update-drawer"
        :title="$t('pages.whats_new.headline')"
        :model-value="visible"
        direction="rtl"
        :with-header="true"
        :before-close="handleClose"
        @update:model-value="$emit('update:visible', $event)"
    >
        <div v-loading="updates.length === 0 && loading" class="content">
            <span v-for="update in updates" :key="update.id" class="entry">
                <h2>{{ update.title }}</h2>
                <h3 style="margin-top: 0; margin-bottom: 5px">
                    <small class="date">{{
                        msTimestampToDate(update.date)
                    }}</small>
                </h3>
                <div v-html="sanitizeHtml(update.text)" />
                <img
                    :src="update.image_url"
                    alt=""
                    style="width: 100%; height: auto"
                />
            </span>
        </div>
    </el-drawer>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { sanitizeHtml } from '@/utils/sanitizeHtml'
import { listUpdates } from "@/api/v2/updates"
import EventBus from "@/eventbus"
import { useFormatters } from "@/composables/useFormatters"
import { useAuthStore } from '@/stores/auth'

const props = defineProps<{
    visible: boolean
}>()

const emit = defineEmits<{
    hide: []
    'update:visible': [value: boolean]
}>()

const authStore = useAuthStore()
const { msTimestampToDate } = useFormatters()

const updates = ref<any[]>([])
const loading = ref(false)

function loadUpdates() {
    loading.value = true
    if (authStore.user_id) {
        const limit = 10
        listUpdates(limit)
            .then((updatesResp) => {
                const updateList = updatesResp.data.data
                EventBus.$emit("nr-of-updates", updateList.length)
                updates.value = updateList
            })
            .catch(() => {})
            .finally(() => {
                loading.value = false
            })
    }
}

function handleClose(done: () => void) {
    emit('hide')
    done()
}

watch(() => props.visible, () => {
    loadUpdates()
})

loadUpdates()
</script>

<style lang="scss" scoped>
@import "@/styles/element-variables.scss";

.update-drawer :deep(header) {
    margin-bottom: 10px;
}

.content {
    padding: 0 20px;
}

h2 {
    color: $--color-primary;
    margin-top: 13px;
    margin-bottom: 0;
    line-height: 1;
}

.date {
    color: #d2d2d2;
    font-size: 12px;
}

.entry {
    width: 100%;
    display: block;
    padding-bottom: 20px;
    border-bottom: 1px solid $--color-info-light;
}
</style>
